var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"industry"},[_c('div',{staticClass:"dynamic"},[_c('div',{staticClass:"dynamic-left"},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('div',{staticClass:"dynamic-right"},[_c('Hotspot')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }